import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const Ctx = createContext(null);
const keyFor = (uid) => `alr_cart_${uid || "anon"}`;
export const lineKey = (l) => (l.machine ? `${l.product.id}__${l.machine}` : l.product.id);

// Cart lines: [{ product, quantity, machine? }], saved per user in this browser.
export const CartProvider = ({ children }) => {
  const { user } = useAuth();
  const [lines, setLines] = useState([]);

  useEffect(() => { setLines(JSON.parse(localStorage.getItem(keyFor(user?.id)) || "[]")); }, [user?.id]);
  const persist = (next) => { setLines(next); localStorage.setItem(keyFor(user?.id), JSON.stringify(next)); };

  const value = useMemo(() => ({
    lines,
    totalCount: lines.reduce((n, l) => n + l.quantity, 0),
    subtotal: lines.reduce((n, l) => n + l.quantity * l.product.price_usd, 0),
    addItem: (product, qty = 1, machine = null) => {
      const k = lineKey({ product, machine });
      const found = lines.find((l) => lineKey(l) === k);
      persist(found ? lines.map((l) => (lineKey(l) === k ? { ...l, quantity: Math.min(99, l.quantity + qty) } : l)) : [...lines, { product, quantity: qty, ...(machine ? { machine } : {}) }]);
    },
    setQty: (k, qty) => persist(qty <= 0 ? lines.filter((l) => lineKey(l) !== k) : lines.map((l) => (lineKey(l) === k ? { ...l, quantity: Math.min(99, qty) } : l))),
    clear: () => persist([]),
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [lines, user?.id]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useCart = () => useContext(Ctx);
